import React from 'react';
import styles from './Advisor.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Section/Header';
import HowItWorks from './Section/HowItWorks';
import FeatureBlocks from './Section/FeatureBlocks';
import Faq from './Section/Faq';
import CallToAction from './Section/CallToAction';

const Advisor = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <HowItWorks />
      <FeatureBlocks />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Advisor;
